import type * as lazyIndex from './lazyIndex';
import { default as setFolderSortBy } from './actions/setFolderSortBy';
import { LazyAction, LazyModule, registerLazyOrchestrator, LazyImport } from 'owa-bundling';
import emptyFolderStoreUpdate from 'owa-folder-emptyfolder/lib/actions/emptyFolderStoreUpdate';
import markAllAsReadStoreUpdate from 'owa-mail-actions/lib/triage/markAllAsReadStoreUpdate';
import {
    onNewFolderNotification,
    onUpdateFolderNotification,
} from 'owa-mail-actions/lib/folderNotificationActions';

export {
    default as getListViewTypeForFolder,
    getListViewTypeForFolderV2,
} from './utils/getListViewTypeForFolder';
export { setFolderSortBy };
export { default as showErrorMessage } from './utils/showErrorMessage';
export { default as loadMailFolders } from './actions/loadMailFolders';
export { default as onFolderCreated } from './actions/onFolderCreated';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "MailFolderStore" */ './lazyIndex'),
    { name: 'MailFolderStore' }
);

registerLazyOrchestrator(
    onNewFolderNotification,
    lazyModule,
    m => m.onNewFolderRowNotificationOrchestrator
);

registerLazyOrchestrator(markAllAsReadStoreUpdate, lazyModule, m => m.markAllAsReadOrchestrator);
registerLazyOrchestrator(
    emptyFolderStoreUpdate,
    lazyModule,
    m => m.emptyFolderStoreUpdateOrchestrator
);
registerLazyOrchestrator(
    onUpdateFolderNotification,
    lazyModule,
    m => m.onUpdateFolderNotificationOrchestrator
);
registerLazyOrchestrator(setFolderSortBy, lazyModule, m => m.setFolderSortByOrchestrator);

export const lazyDismissMailFolderTextField: LazyAction<
    typeof lazyIndex.dismissMailFolderTextFieldMutator,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.dismissMailFolderTextFieldMutator);

export const lazyRemoveSortByOverride: LazyAction<
    typeof lazyIndex.removeSortByOverrideMutator,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.removeSortByOverrideMutator);

export const lazyGetFolderUrl: LazyImport<typeof lazyIndex.getFolderUrl, typeof lazyModule> =
    new LazyImport(lazyModule, m => m.getFolderUrl);

export const lazyGetFolderViewStateFromId: LazyImport<
    typeof lazyIndex.getFolderViewStateFromId,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getFolderViewStateFromId);

export { getShouldOverrideToSortBySizeForMailFolder } from './utils/getShouldOverrideToSortBySizeForMailFolder';
export { FolderContextMenuState } from './store/schema/FolderContextMenuState';

export const lazySetCustomFolderColor: LazyAction<
    typeof lazyIndex.setCustomFolderColorMutator,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.setCustomFolderColorMutator);

export const lazySetFolderCountDisplayMode: LazyAction<
    typeof lazyIndex.setFolderCountDisplayModeMutator,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.setFolderCountDisplayModeMutator);
